import gettext from '@sdk/lang/gettext';
import { Shift } from '@sdk/automatedBreaks/types/Shift';

import ModalRow from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/ModalRow';
import ScheduledRowContent from '@web/timeClock/modals/rows/ScheduledRow/ScheduledRowContent';
import TimeIconSvg from '@web/assets/svg/Icons/32/time-gray.svg';

type Props = {
  shift: Shift;
};

const ScheduledRow = ({ shift }: Props) => (
  <ModalRow label={gettext('Scheduled')} icon={TimeIconSvg} mTop={0}>
    <ScheduledRowContent shift={shift} />
  </ModalRow>
);

export default ScheduledRow;
